import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function getWmsOrdersByDMSOrderId(request) {
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  const apiPath = `v1/getWMSOrders?dmsOrderId=${request.dmsOrderId}&orderStatus=${request.orderStatus}`
  return httpClient.shippingInstance().get(apiPath)
}
